import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import CommentsPanel from 'src/client/components/Blog/CommentsPanel';
import { loadLatest } from 'src/client/redux/modules/comments';
import { rateItem } from 'src/client/redux/modules/ratingInfo';
import { badgeMap } from 'src/client/helpers';
import { useSelector } from 'src/client/redux/modules/helpers/useSelector';
import { useShowSfwSite } from 'src/client/helpers/useFeatureFlags';

const pageSize = 10;
const expandedPageSize = 20;

export default function LatestComments() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const { latest: comments, latestError, latestExpanded, latestLoading } = useSelector((state) => state.comments);
  const ratings = useSelector((state) => state.ratingInfo.ratings);

  const loadData = useCallback(
    ({ first = pageSize, after = 0 }) => {
      const loadParams = {
        first,
        after,
      };

      dispatch(loadLatest(loadParams));
    },
    [dispatch],
  );

  useEffect(() => {
    loadData({});
  }, [loadData]);

  const expand = useCallback(() => {
    loadData({
      first: pageSize,
      after: expandedPageSize - pageSize,
    });
  }, [loadData]);

  const comment2Props = useCallback(
    (comment) => {
      const isRated = ratings[comment.UUID] === 1;
      const badgeId = comment.badges;

      return {
        badge: badgeMap[badgeId],
        displayName: comment.userDisplayName,
        isRated,
        link: `${comment.object.path}/#comment_${comment.UUID.substring(0, 6)}`,
        linkText: comment.object.name,
        onRate: () =>
          dispatch(
            rateItem({
              objectUUID: comment.UUID,
              objectType: 'COMMENT',
              rating: isRated ? 0 : 1,
            }),
          ),
        ratesCount: comment.rating || 0,
        text: comment.text,
        timestamp: comment.timestamp,
        UUID: comment.UUID,
      };
    },
    [dispatch, ratings],
  );

  const isUser = useMemo(() => user && user.validSubscription, [user]);

  const showSfwSite = useShowSfwSite();
  if (showSfwSite) {
    return null;
  }

  return (
    <CommentsPanel
      comments={comments.map((comment) => comment2Props(comment))}
      error={latestError}
      expand={expand}
      expanded={latestExpanded}
      isUser={isUser}
      load={() => loadData({})}
      loading={latestLoading}
      showUpgradeDialog={() => {}} // TODO: not in use, need to modify man-ui
    />
  );
}
